import React from 'react';
import CallInformation from '../../../containers/CallInformation/CallInformation';

interface TrainerOverlaysProps {
    displayRealTimeHints: boolean;
    callPopup: React.ReactNode;
    callButton: React.ReactNode;
    conversionModal: React.ReactNode;
    audioDeviceSelectorModal: React.ReactNode;
}

export function TrainerOverlays({
    displayRealTimeHints,
    callPopup,
    callButton,
    conversionModal,
    audioDeviceSelectorModal
}: TrainerOverlaysProps) {
    return (
        <div data-testid="trainer-runtime-section">
            <div data-testid="trainer-call-information-section">{displayRealTimeHints ? <CallInformation /> : null}</div>
            <div data-testid="trainer-call-popup-section">{callPopup}</div>
            <div data-testid="trainer-call-button-section">{callButton}</div>
            <div data-testid="trainer-conversion-modal-section">{conversionModal}</div>
            <div data-testid="trainer-audio-device-modal-section">{audioDeviceSelectorModal}</div>
        </div>
    );
}
